import React from "react";

export default ({ data }) => {
  return (
    <table>
      <thead>
        <tr>
          <th
            colSpan="2"
            style={{ color: "#007cba", backgroundColor: "#ebf5fa" }}
          >
            Top 10 Donations
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return (
            <tr key={index}>
              <td className="center">{item.donor}</td>
              <td className="right">{item.amt}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
